// extracted by mini-css-extract-plugin
export default {"root":"ChecksContent_root__7pu5Y"};